import { render, staticRenderFns } from "./AuditoriaClientes.vue?vue&type=template&id=2192369f&"
import script from "./AuditoriaClientes.vue?vue&type=script&lang=ts&"
export * from "./AuditoriaClientes.vue?vue&type=script&lang=ts&"
import style0 from "./AuditoriaClientes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports